import { render, staticRenderFns } from "./TermsCheckbox.vue?vue&type=template&id=2e019ab1"
import script from "./TermsCheckbox.vue?vue&type=script&lang=js"
export * from "./TermsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports